@if (false) {
    <app-no-permission />
} @else {
    <section class="flex flex-col h-full gap-7">
        <div class="flex">
            <app-management-main-panel-title
                [icon]="['fas', 'bell']"
                [title]="'Notification'" />
        </div>
        <div class="flex flex-row gap-6">
            <div class="flex flex-col gap-1 flex-[2] min-h-0">
                <app-notification-field-intervention-select
                    [allSelected]="selectAllFieldIntervention()"
                    [selectedItems]="selectedFieldInterventionIds()"
                    (toggleSelect)="toggleSelection($event.all, 'FieldIntervention', $event.id)" />

                <app-notification-operator-select
                    [allSelected]="selectAllPeople()"
                    [selectedItems]="selectedOperatorIds()"
                    (toggleSelect)="toggleSelection($event.all, 'People', $event.id)" />
            </div>
            <div class="flex flex-col gap-1 flex-[1] min-h-0">
                <app-notification-form
                    [isAllOperatorSelected]="selectAllPeople()"
                    [selectedFieldInterventionIds]="selectedFieldInterventionIds()"
                    [selectedOperatorIds]="selectedOperatorIds()" />
            </div>
        </div>
    </section>
}
